<script>

import {SpeakerMixin} from "../lib/speaker-utils.js"

export default {
  mixins: [SpeakerMixin],
  props: {
    speaker: {type: Object, required: true},
    isModerator: {type: Boolean, default: false},
  },

  methods: {
    onSpeakerClick() {
      this.$emit('speaker-click', this.speaker)
      this.$router.push(this.speakerUrl(this.speaker))
    }
  }
}

</script>

<template>

  <a href="" @click.prevent="onSpeakerClick">
    <div class="d-flex align-items-center" style="gap: 15px">
      <img width="60" height="60" style="object-fit: cover" class="rounded-circle" :src="speaker.profile_img_url" />
      <div>
        <div class="font-weight-bold">{{speakerFullName(speaker)}}</div>
        <p v-if="speaker.job_title" class="text-muted">
          <small>{{speaker.job_title}}</small>
          <small v-if="isModerator"><br>Moderator:in</small>
        </p>
        <div v-if="speaker.company">{{speaker.company}}</div>
      </div>
    </div>
  </a>

</template>

<style scoped>

a { text-decoration:none}

</style>